module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/154-swaziland-50342fb77b3e2276f74b4815efaae4f9.svg";